module.exports = __webpack_public_path__ + "static/media/IMG_3693.8a8f1b4b.jpg";